// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes an existing URL link.
 *
 * @param urlLinkKey - The key of the URL link to delete.
 */
export async function deleteURLLink(urlLinkKey: string) {
  const path = `/v1/url-link/${urlLinkKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteURLLink',
    endpoint: path,
  });
}
